import { useState, useContext, Fragment, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useFormUploadLicenses from "../lib/useFormUploadLicenses";
import { ReactComponent as UploadIcon } from "../../Asset/upload-cloud-02.svg";
import Spinner from "../../Utils/spinner/loading";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { RiDeleteBin5Line } from "react-icons/ri";
import { CiFileOn } from "react-icons/ci";
import useFormUploadOtherDocs_v from "../../vesselOwner/Libs/useVesselOwnerOtherDoc";
import useFormUploadOtherDocs from "../../Charterer/lib/useFormUploadOtherDocs";
import { AuthContext } from "../../Context/AuthContext";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import "./license.css";

const Licenses = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { handleSubmit, loading, error, success } = useFormUploadLicenses();
  const {
    handleSkip,
  } = useFormUploadOtherDocs();
  const {
    handleSkip: handleSkip_v,
  } = useFormUploadOtherDocs_v();
  const [formData, setFormData] = useState({
    dpr: null,
    nimasa: null,
    npa: null,
  });
  const [fileDetails, setFileDetails] = useState({
    dpr: null,
    nimasa: null,
    npa: null,
  });

  
  const [licensesSubmitted, setLicensesSubmitted] = useState(false);


  // Auto-skip additional documents after licenses are successfully submitted
  useEffect(() => {
    if (success && !licensesSubmitted) {
      setLicensesSubmitted(true);
      // Automatically call handleNoClick to skip additional documents
      if (user.role === "charterer") {
        handleSkip();
      } else if (user.role === "vesselOwner") {
        handleSkip_v();
      }
    }
  }, [success, licensesSubmitted, user.role, handleSkip, handleSkip_v]);


  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      [fieldName]: file,
    });

    const fileDetail = {
      name: file.name,
      size: file.size,
    };
    setFileDetails({
      ...fileDetails,
      [fieldName]: fileDetail,
    });
  };

  const handleFileDelete = (fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: null,
    });
    setFileDetails({
      ...fileDetails,
      [fieldName]: null,
    });
  };

  const handleFinish = (e) => {
    e.preventDefault();
    handleSubmit(e, formData);
  };

  const formatFileSize = (size) => {
    if (size >= 1000000) {
      return (size / 1000000).toFixed(2) + " MB";
    } else if (size >= 1000) {
      return (size / 1000).toFixed(2) + " KB";
    } else {
      return size + " bytes";
    }
  };

  return (
    <Fragment>

      <div className="licenses-container">
        <div className="wrap">
        <div className="header">
          <button onClick={() => navigate("/typeofupdate")}>Back</button>
          {/* <Link to="/">Charterer</Link> */}
          <BlackVatugIcon  onClick={() => navigate("/")}/>
          <button
            className="finished"
            onClick={handleFinish}
            disabled={loading}
          >
            {loading ? <Spinner /> : "Finish"}
          </button>
        </div>
        <form>
          <h2>Licenses</h2>

          {!fileDetails.dpr && (
            <label>
              DPR
              <span>
                <input
                  type="file"
                  hidden
                  onChange={(e) => handleFileChange(e, "dpr")}
                  accept="application/pdf"
                />
                <>
                  <UploadIcon />
                  <p>
                    Drop pdf here, <span>or browse</span>
                  </p>
                  <h5>Supports: PDF</h5>
                </>
              </span>
            </label>
          )}

          {fileDetails.dpr && (
            <div className="uploaded">
              <div className="wrap">
                <CiFileOn className="file" />
                <div className="in">
                  <span>
                    <h3>{fileDetails.dpr.name}</h3>
                  </span>
                  <p>{formatFileSize(fileDetails.dpr.size)} - 100% Uploaded</p>
                </div>
              </div>
              <div className="last">
                <IoCheckmarkDoneCircleOutline className="mark" />
                <RiDeleteBin5Line
                  onClick={() => handleFileDelete("dpr")}
                  className="delete"
                />
              </div>
            </div>
          )}

          {!fileDetails.nimasa && (
            <label>
              NIMASA
              <span>
                <input
                  type="file"
                  hidden
                  onChange={(e) => handleFileChange(e, "nimasa")}
                  accept="application/pdf"
                />
                <>
                  <UploadIcon />
                  <p>
                    Drop pdf here, <span>or browse</span>
                  </p>
                  <h5>Supports: PDF</h5>
                </>
              </span>
            </label>
          )}

          {fileDetails.nimasa && (
            <div className="uploaded">
              <div className="wrap">
                <CiFileOn className="file" />
                <div className="in">
                  <span>
                    <h3>{fileDetails.nimasa.name}</h3>
                  </span>
                  <p>
                    {formatFileSize(fileDetails.nimasa.size)} - 100% Uploaded
                  </p>
                </div>
              </div>
              <div className="last">
                <IoCheckmarkDoneCircleOutline className="mark" />
                <RiDeleteBin5Line
                  onClick={() => handleFileDelete("nimasa")}
                  className="delete"
                />
              </div>
            </div>
          )}

          {!fileDetails.npa && (
            <label>
              NPA
              <span>
                <input
                  type="file"
                  hidden
                  onChange={(e) => handleFileChange(e, "npa")}
                  accept="application/pdf"
                />
                <>
                  <UploadIcon />
                  <p>
                    Drop pdf here, <span>or browse</span>
                  </p>
                  <h5>Supports: PDF</h5>
                </>
              </span>
            </label>
          )}

          {fileDetails.npa && (
            <div className="uploaded">
              <div className="wrap">
                <CiFileOn className="file" />
                <div className="in">
                  <span>
                    <h3>{fileDetails.npa.name}</h3>
                  </span>
                  <p>{formatFileSize(fileDetails.npa.size)} - 100% Uploaded</p>
                </div>
              </div>
              <div className="last">
                <IoCheckmarkDoneCircleOutline className="mark" />
                <RiDeleteBin5Line
                  onClick={() => handleFileDelete("npa")}
                  className="delete"
                />
              </div>
            </div>
          )}

          <button
            className="finished"
            onClick={handleFinish}
            disabled={loading}
          >
            {loading ? <Spinner /> : "Finish"}
          </button>

          {error && (
            <p
              style={{ margin: "auto", color: "red", fontFamily: "Montserrat" }}
            >
              {error}
            </p>
          )}
          {success && (
            <p
              style={{
                margin: "auto",
                color: "green",
                fontFamily: "Montserrat",
              }}
            >
              {success}
            </p>
          )}
        </form>
        </div>
      </div>
    </Fragment>
  );
};

export default Licenses;
